import { driversService, IDriverAddress, IDriverUpdateAddressPayload } from '../../../services/Drivers'
import * as constants from '../../constants/'
import {
  IDriverAccumulatedHours,
  IDriverAddSessionObject,
  IDriverDeleteSessionObject,
  IDriverEditSessionObject,
  IDriverScheduleDTO as IGetDriverScheduleDTO,
  IDriverSessionFilters,
  IDriverSessionSearchObject,
  IHistoryDriverTrips,
  IStateDriver,
  IUpdateDriver,
  IOperatorLocation,
  IGetManyTripsPerOperatorResponse,
  IDriverSessionHistoryResponse,
  IDriverSessionHistoryItem,
  IDriverMetricsResponse,
  IDriverMetricsFilters,
  IDriverMetricsDTO
} from '../../../types/'
import {
  ICreateDriver,
  ActionsUnion,
  IMap,
  IPingDTO,
  IDriverFilters,
  IDriverSearchObject,
  IDriverSessionHistoryFilters
} from '../../../types'
import { createAction } from '../helpers'
import history from '../../../history'
import { IDriverScheduleDTO } from 'src/components/drivers/DriverEditSchedule'
import moment from 'moment'
import { getMetricsFromLocalStorage, getStorageKey, saveMetricsToLocalStorage } from './local-storage'
;(window as any).driverService = driversService

export const actionCreators = {
  updateDriverFilters: (filters: IDriverFilters) => createAction(constants.UPDATE_DRIVER_FILTERS, filters),

  addProductsToDriverRequest: () => createAction(constants.ADD_PRODUCTS_TO_DRIVER_REQUEST),
  addProductsToDriverSuccess: (message: string) =>
    createAction(constants.ADD_PRODUCTS_TO_DRIVER_SUCCESS_MESSAGE, message),
  addProductsToDriverFail: (error: string) => createAction(constants.ADD_PRODUCTS_TO_DRIVER_FAIL, error),

  archiveDriverRequest: () => createAction(constants.TO_ARCHIVED_DRIVER_REQUEST),
  archiveDriverSuccess: (driver: IDriverSearchObject) => createAction(constants.DRIVER_ARCHIVE_RESTORE_SUCCESS, driver),
  archiveDriverFail: (error: string) => createAction(constants.TO_ARCHIVED_DRIVER_FAIL, error),

  driversListRequest: () => createAction(constants.DRIVERS_LIST_REQUEST),
  driversListSuccess: (driversWithTotal: { drivers: IMap<IDriverSearchObject>; total: number }) =>
    createAction(constants.DRIVERS_LIST_SUCCESS, driversWithTotal),
  driversListFail: (error: string) => createAction(constants.DRIVERS_LIST_FAIL, error),

  driverSessionListRequest: () => createAction(constants.DRIVER_SESSION_LIST_REQUEST),
  driverSessionListSuccess: (driverSessionWithTotal: { drivers: IDriverSessionSearchObject[]; total: number }) =>
    createAction(constants.DRIVER_SESSION_LIST_SUCCESS, driverSessionWithTotal),
  driverSessionListFail: (error: string) => createAction(constants.DRIVER_SESSION_LIST_FAIL, error),

  driverSessionListV2Request: () => createAction(constants.DRIVER_SESSION_LIST_V2_REQUEST),
  driverSessionListV2Success: (driverSessionWithTotal: { drivers: IDriverSessionHistoryItem[]; total: number }) =>
    createAction(constants.DRIVER_SESSION_LIST_V2_SUCCESS, driverSessionWithTotal),
  driverSessionListV2Fail: (error: string) => createAction(constants.DRIVER_SESSION_LIST_V2_FAIL, error),

  driverCreateSessionRequest: () => createAction(constants.DRIVER_CREATE_SESSION_REQUEST),
  driverCreateSessionSuccess: (session: IDriverSessionSearchObject) =>
    createAction(constants.DRIVER_CREATE_SESSION_SUCCESS, session),
  driverCreateSessionFail: (error: string) => createAction(constants.DRIVER_CREATE_SESSION_FAIL, error),

  driverEditSessionRequest: () => createAction(constants.DRIVER_EDIT_SESSION_REQUEST),
  driverEditSessionSuccess: (session: IDriverSessionSearchObject) =>
    createAction(constants.DRIVER_EDIT_SESSION_SUCCESS, session),
  driverEditSessionFail: (error: string) => createAction(constants.DRIVER_EDIT_SESSION_FAIL, error),

  driverDeleteSessionRequest: () => createAction(constants.DRIVER_DELETE_SESSION_REQUEST),
  driverDeleteSessionSuccess: (session: IDriverSessionSearchObject) =>
    createAction(constants.DRIVER_DELETE_SESSION_SUCCESS, session),
  driverDeleteSessionFail: (error: string) => createAction(constants.DRIVER_DELETE_SESSION_FAIL, error),

  liveOperatorsRequest: () => createAction(constants.LIVE_OPERATORS_REQUEST),
  liveOperatorsSuccess: (liveDrivers: IPingDTO[]) => createAction(constants.LIVE_OPERATORS_SUCCESS, liveDrivers),
  liveOperatorsFail: (error: string) => createAction(constants.LIVE_OPERATORS_FAIL, error),

  fetchDriverRequest: () => createAction(constants.FETCH_DRIVER_REQUEST),
  fetchDriverSuccess: (driver: IDriverSearchObject) => createAction(constants.FETCH_DRIVER_SUCCESS, driver),
  fetchDriverFail: (error: string) => createAction(constants.FETCH_DRIVER_FAIL, error),

  driverGetAccumulatedHoursRequest: () => createAction(constants.DRIVER_GET_ACCUMULATED_HOURS_REQUEST),
  driverGetAccumulatedHoursSuccess: (driverAccumulatedHours: IDriverAccumulatedHours) =>
    createAction(constants.DRIVER_GET_ACCUMULATED_HOURS_SUCCESS, driverAccumulatedHours),
  driverGetAccumulatedHoursFail: (error: string) => createAction(constants.DRIVER_GET_ACCUMULATED_HOURS_FAIL, error),

  removeProductRequest: () => createAction(constants.OPERATOR_REMOVE_PRODUCT_REQUEST),
  removeProductSuccess: (driver: IStateDriver) => createAction(constants.OPERATOR_REMOVE_PRODUCT_SUCCESS, driver),
  removeProductFail: (error: string) => createAction(constants.OPERATOR_REMOVE_PRODUCT_FAILURE, error),

  saveDriverInfoRequest: () => createAction(constants.ADD_DRIVER_INFO_REQUEST),
  saveDriverInfoSuccess: (driver: IStateDriver) => createAction(constants.ADD_DRIVER_INFO_SUCCESS, driver),
  saveDriverInfoFail: (error: string) => createAction(constants.ADD_DRIVER_INFO_FAIL, error),

  tripHistoryRequest: () => createAction(constants.TRIP_HISTORY_DRIVER_REQUEST),
  tripHistorySuccess: (trips: IHistoryDriverTrips[]) => createAction(constants.TRIP_HISTORY_DRIVER_SUCCESS, trips),
  tripHistoryFail: (error: string) => createAction(constants.TRIP_HISTORY_DRIVER_FAIL, error),

  unarchiveDriverRequest: () => createAction(constants.RESTORE_ARCHIVED_DRIVER_REQUEST),
  unarchiveDriverSuccess: (driver: IDriverSearchObject) =>
    createAction(constants.DRIVER_ARCHIVE_RESTORE_SUCCESS, driver),
  unarchiveDriverFail: (error: string) => createAction(constants.RESTORE_ARCHIVED_DRIVER_FAIL, error),

  getOperatorScheduleRequest: () => createAction(constants.GET_OPERATOR_SCHEDULE_REQUEST),
  getOperatorScheduleSuccess: (response: IGetDriverScheduleDTO[]) =>
    createAction(constants.GET_OPERATOR_SCHEDULE_SUCCESS, response),
  getOperatorScheduleFail: (error: string) => createAction(constants.GET_OPERATOR_SCHEDULE_FAIL, error),

  getOperatorMetricsRequest: () => createAction(constants.GET_OPERATOR_METRICS_REQUEST),
  getOperatorMetricsSuccess: (response: IDriverMetricsDTO[]) =>
    createAction(constants.GET_OPERATOR_METRICS_SUCCESS, response),
  getOperatorMetricsFail: (error: string) => createAction(constants.GET_OPERATOR_METRICS_FAIL, error),

  getLocationRequest: () => createAction(constants.GET_OPERATOR_LOCATION_REQUEST),
  getLocationSuccess: (data: IOperatorLocation) => createAction(constants.GET_OPERATOR_LOCATION_SUCCESS, data),
  getLocationFail: (error: any) => createAction(constants.GET_OPERATOR_LOCATION_FAIL, error),

  driverPushNotificationSuccess: (message: string) =>
    createAction(constants.DRIVER_PUSH_NOTIFICATION_SUCCESS_MESSAGE, message),
  driverPushNotificationFailure: (message: string) => createAction(constants.DRIVER_PUSH_NOTIFICATION_FAIL, message)
}

export function getProductOperators(productIds: string[]) {
  const { liveOperatorsRequest, liveOperatorsSuccess, liveOperatorsFail } = actionCreators
  return (dispatch: any) => {
    dispatch(liveOperatorsRequest())
    return driversService.getProductOperators(productIds).then(
      (data: any) => {
        dispatch(liveOperatorsSuccess(data))
        return data
      },
      ({ data }: any) => dispatch(liveOperatorsFail(data))
    )
  }
}

export function getOrgOperators(orgId: string) {
  const { liveOperatorsRequest, liveOperatorsSuccess, liveOperatorsFail } = actionCreators
  return (dispatch: any) => {
    dispatch(liveOperatorsRequest())
    return driversService.getOrgOperators(orgId).then(
      (data: any) => {
        dispatch(liveOperatorsSuccess(data))
        return data
      },
      ({ data }: any) => dispatch(liveOperatorsFail(data.statusText))
    )
  }
}

export function getOperatorSchedule() {
  const { getOperatorScheduleRequest, getOperatorScheduleSuccess, getOperatorScheduleFail } = actionCreators

  return (dispatch: any) => {
    dispatch(getOperatorScheduleRequest())
    return driversService
      .getOperatorSchedule()
      .then((data: any) => {
        const { serviceDays: operatorScheduled, success } = data
        success
          ? dispatch(getOperatorScheduleSuccess(operatorScheduled))
          : dispatch(getOperatorScheduleFail('Error fetching operator schedule'))
      })
      .catch(() => dispatch(getOperatorScheduleFail('Error fetching operator schedule')))
  }
}

export function getDriversList(filters: IDriverFilters) {
  const { driversListRequest, driversListSuccess, driversListFail } = actionCreators
  return (dispatch: any) => {
    dispatch(driversListRequest())
    return driversService.getMany(filters).then(
      async (data: { total: number; items: IDriverSearchObject[] }) => {
        const drivers = {}
        const operatorIds: any = []
        data.items.forEach((d: any) => {
          drivers[d.id] = d
          operatorIds.push(d.id)
        })
        // try {
        //   const vehicleDetails = await ServiceVehicles.getVehicleByOperatorIds({ operatorIds })
        //   vehicleDetails.data.forEach((chunk: any) => {
        //     for (const dr in drivers) {
        //       if (drivers.hasOwnProperty(dr)) {
        //         if (dr === chunk.operator) {
        //           drivers[dr].vehicle = chunk
        //         }
        //       }
        //     }
        //   })
        // } catch (err) {
        //   console.log('Fetching vehicle information failed', err)
        // }
        dispatch(
          driversListSuccess({
            drivers,
            total: data.total
          })
        )
        return data
      },
      (error: string) => dispatch(driversListFail(error))
    )
  }
}

export function getDriverSessionList(filters: IDriverSessionFilters) {
  const { driverSessionListRequest, driverSessionListSuccess, driverSessionListFail } = actionCreators
  return (dispatch: any) => {
    dispatch(driverSessionListRequest())
    return driversService.getSessionHistory(filters).then(
      (data: { total: number; items: IDriverSessionSearchObject[] }) => {
        dispatch(
          driverSessionListSuccess({
            drivers: data.items,
            total: data.total
          })
        )
        return data
      },
      (error: string) => dispatch(driverSessionListFail(error))
    )
  }
}

export function getDriverSessionListV2(filters: IDriverSessionFilters) {
  const { driverSessionListV2Request, driverSessionListV2Success, driverSessionListV2Fail } = actionCreators
  return (dispatch: any) => {
    dispatch(driverSessionListV2Request())
    return driversService.getSessionHistoryV2(filters).then(
      (data: IDriverSessionHistoryResponse) => {
        dispatch(
          driverSessionListV2Success({
            drivers: data.items,
            total: data.total
          })
        )
        return data
      },
      (error: string) => dispatch(driverSessionListV2Fail(error))
    )
  }
}

export function getOperatorMetrics(filters: IDriverMetricsFilters) {
  const { getOperatorMetricsRequest, getOperatorMetricsSuccess, getOperatorMetricsFail } = actionCreators
  return (dispatch: any) => {
    const storageKey = getStorageKey(filters)
    const storedMetrics = getMetricsFromLocalStorage(storageKey)

    if (storedMetrics) {
      dispatch(getOperatorMetricsSuccess(storedMetrics))
      return Promise.resolve(storedMetrics)
    }

    dispatch(getOperatorMetricsRequest())
    return driversService.getOperatorMetrics(filters).then(
      (data: IDriverMetricsResponse) => {
        dispatch(getOperatorMetricsSuccess(data.items))
        saveMetricsToLocalStorage(storageKey, data.items)
        return data
      },
      (error: string) => dispatch(getOperatorMetricsFail(error))
    )
  }
}

export function createDriverSession(request: IDriverAddSessionObject) {
  const { driverCreateSessionRequest, driverCreateSessionSuccess, driverCreateSessionFail } = actionCreators
  return (dispatch: any) => {
    dispatch(driverCreateSessionRequest())
    return driversService.createDriverSession(request).then(
      (data: any) => {
        const sessionObject: IDriverSessionSearchObject = {
          duration: data && data.session && data.session.duration ? data.session.duration : 0,
          checkInTime: data && data.session && data.session.checkInTime ? data.session.checkInTime : null,
          distance: data && data.session && data.session.distanceTravel ? data.session.distanceTravel : null,
          trip_duration: 0,
          estimated_duration: 0,
          driving_duration: 0,
          service_duration: 0,
          fare: 0,
          revenue: 0,
          completed_trips_count: 0,
          assigned_trips_count: 0,
          modifyDate: ''
        }
        // dispatch(driverCreateSessionSuccess(sessionObject))
        const fromDate = request.fromDate
        const toDate = request.toDate
        dispatch(
          getDriverSessionListV2({
            operatorId: request.operatorId,
            fromDate,
            toDate,
            timeZone: moment(fromDate).format('Z')
          })
        )
        return data
      },
      (error: string) => dispatch(driverCreateSessionFail(error))
    )
  }
}

export function editDriverSession(request: IDriverEditSessionObject) {
  const { driverEditSessionRequest, driverEditSessionFail, driverEditSessionSuccess } = actionCreators

  return (dispatch: any) => {
    dispatch(driverEditSessionRequest())
    return driversService.editDriverSession(request).then(
      (data: any) => {
        return data
      },
      (error: string) => dispatch(driverEditSessionFail(error))
    )
  }
}

export function deleteDriverSession(request: IDriverDeleteSessionObject) {
  const { driverDeleteSessionRequest, driverDeleteSessionFail, driverDeleteSessionSuccess } = actionCreators

  return (dispatch: any) => {
    dispatch(driverDeleteSessionRequest())
    return driversService.deleteDriverSession(request).then(
      (data: any) => {
        return data
      },
      (error: string) => dispatch(driverDeleteSessionFail(error))
    )
  }
}

export function getDriverCheckInCheckOut(filters: IDriverSessionHistoryFilters) {
  return driversService.getCheckInCheckOut(filters).then((data: any) => {
    return data
  })
}

export function getDriverCheckInCheckOutV1(filters: IDriverSessionHistoryFilters) {
  return driversService.getCheckInCheckOut(filters).then((data: any) => {
    return data
  })
}

export function getManyTripsPerOperator(filters: IDriverSessionHistoryFilters) {
  return driversService.getManyTripsPerOperator(filters).then((data: any) => {
    return data
  })
}

export function getManyTripsPerOperatorV2(filters: IDriverSessionHistoryFilters) {
  return driversService.getManyTripsPerOperatorV2(filters).then((data: IGetManyTripsPerOperatorResponse) => {
    return data
  })
}

export function archiveDriver(driver: IDriverSearchObject) {
  const { archiveDriverRequest, archiveDriverSuccess, archiveDriverFail } = actionCreators
  return (dispatch: any) => {
    dispatch(archiveDriverRequest())
    return driversService
      .archiveDriver(driver.id)
      .then(
        (item: { archived: boolean }) => dispatch(archiveDriverSuccess(driver)),
        ({ data }) => dispatch(archiveDriverFail(data))
      )
  }
}

export function restoreFromArchive(driver: IDriverSearchObject) {
  const { unarchiveDriverRequest, unarchiveDriverSuccess, unarchiveDriverFail } = actionCreators
  return (dispatch: any) => {
    dispatch(unarchiveDriverRequest())
    return driversService
      .unarchiveDriver(driver.id)
      .then(
        (item: { archived: boolean }) => dispatch(unarchiveDriverSuccess(driver)),
        ({ data }) => dispatch(unarchiveDriverFail(data))
      )
  }
}

export function getTripsHistoryDriver() {
  const { tripHistoryRequest, tripHistorySuccess, tripHistoryFail } = actionCreators
  return (dispatch: any) => {
    dispatch(tripHistoryRequest())
    driversService
      .driverTripsHistoryDriver()
      .then(
        (items: IHistoryDriverTrips[]) => dispatch(tripHistorySuccess(items)),
        (error: string) => dispatch(tripHistoryFail(error))
      )
  }
}

export function addDriverInfo(payload: ICreateDriver) {
  const { saveDriverInfoFail, saveDriverInfoRequest, saveDriverInfoSuccess } = actionCreators
  return (dispatch: any) => {
    dispatch(saveDriverInfoRequest())
    return driversService.addDriverInfo(payload).then(
      (driver: IStateDriver) => {
        const driverAddress = {
          street: payload.street ? payload.street : '',
          city: payload.city ? payload.city : '',
          state: payload.state ? payload.state : '',
          zip: payload.zip ? payload.zip : '',
          country: payload.country ? payload.country : '',
          coordinates: {
            latitude: 0,
            longitude: 0
          },
          fullAddress: '',
          isNew: true,
          placeName: '',
          streetNumber: '',
          timeZone: '',
          unit: ''
        }
        return driversService.saveDriverAddress(driver.id, driverAddress).then(() => {
          dispatch(saveDriverInfoSuccess(driver))
          history.push(`/drivers/create/${driver.id}/add-products`)
          return driver
        })
      },
      ({ data }) => dispatch(saveDriverInfoFail(data))
    )
  }
}

export function removeProduct(driverId: string, productId: string) {
  const { removeProductRequest, removeProductSuccess, removeProductFail } = actionCreators
  return (dispatch: any) => {
    dispatch(removeProductRequest())
    return driversService.removeProduct(driverId, productId).then(
      (driver: IStateDriver) => {
        dispatch(removeProductSuccess(driver))
      },
      ({ data }) => {
        dispatch(removeProductFail(data))
      }
    )
  }
}

export function addProductsToDriver(driverId: string, productIds: string[], organizationId: string) {
  const { addProductsToDriverRequest, addProductsToDriverSuccess, addProductsToDriverFail } = actionCreators
  return (dispatch: any) => {
    dispatch(addProductsToDriverRequest())
    return driversService.addProductsToDriver(driverId, productIds, organizationId).then(
      () => {
        const message = 'Operator products successfully saved.'
        dispatch(addProductsToDriverSuccess(message))
      },
      ({ data }) => dispatch(addProductsToDriverFail(data))
    )
  }
}

export function updateDriverInfo(driverInfo: IUpdateDriver) {
  const { saveDriverInfoRequest, saveDriverInfoSuccess, saveDriverInfoFail } = actionCreators
  return (dispatch: any) => {
    dispatch(saveDriverInfoRequest())
    const driverAddress: IDriverAddress = {
      id: driverInfo.addressId ? driverInfo.addressId : '',
      street: driverInfo.street ? driverInfo.street : '',
      city: driverInfo.city ? driverInfo.city : '',
      state: driverInfo.state ? driverInfo.state : '',
      zip: driverInfo.zip ? driverInfo.zip : '',
      country: driverInfo.country ? driverInfo.country : '',
      coordinates: {
        latitude: 0,
        longitude: 0
      },
      fullAddress: '',
      isNew: driverInfo.addressId ? false : true,
      placeName: '',
      streetNumber: '',
      timeZone: '',
      unit: ''
    }

    const addressPayload: IDriverUpdateAddressPayload = {
      operatorId: driverInfo.id,
      locations: [driverAddress]
    }

    if (driverInfo.addressId !== undefined && driverInfo.addressId !== '' && driverInfo.addressId !== null) {
      driversService.updateDriverAddress(addressPayload)
    } else {
      driversService.saveDriverAddress(driverInfo.id, driverAddress)
    }

    return driversService
      .updateDriverInfo(driverInfo)
      .then((driver: IStateDriver) => {
        dispatch(saveDriverInfoSuccess(driver))
        return driver
      })
      .catch(({ data }) => dispatch(saveDriverInfoFail(data)))
  }
}

export function getSingleDriver(id: string) {
  const { fetchDriverRequest, fetchDriverSuccess, fetchDriverFail } = actionCreators
  return (dispatch: any) => {
    dispatch(fetchDriverRequest())
    driversService.getDriverById(id).then(
      async (item: IDriverSearchObject) => {
        const address = await driversService.getDriverAddress(item.id)
        if (address.length > 0) {
          const driverAddress = address[0]
          const { id, street, city, state, zip, country } = driverAddress
          const driver = {
            ...item,
            addressId: id,
            street,
            city,
            state,
            zip,
            country
          }
          return dispatch(fetchDriverSuccess(driver))
        } else {
          return dispatch(fetchDriverSuccess(item))
        }
      },
      (error: string) => dispatch(fetchDriverFail(error))
    )
  }
}

export async function getDriverSessionListPerDate(dto: IDriverSessionFilters): Promise<any> {
  return await driversService
    .getSessionHistoryV2(dto)
    .then(result => {
      return result
    })
    .catch(error => {
      console.log(error)
      return null
    })
}

export async function getDriverSchedule(operatorId: string): Promise<any> {
  return await driversService
    .getDriverSchedule(operatorId)
    .then(result => {
      return result
    })
    .catch(error => {
      console.log(error)
      return null
    })
}

export async function updateDriverSchedule(dto: IDriverScheduleDTO): Promise<any> {
  return await driversService
    .updateDriverSchedule(dto)
    .then(result => {
      return result
    })
    .catch(error => {
      console.log(error)
      return null
    })
}

export function getOperatorLocation(operatorId: string) {
  const { getLocationRequest, getLocationSuccess, getLocationFail } = actionCreators
  return (dispatch: any) => {
    dispatch(getLocationRequest())
    return driversService.getOperatorLocation(operatorId).then(
      (data: any) => {
        dispatch(getLocationSuccess(data))
        return data
      },
      ({ data }: any) => dispatch(getLocationFail(data))
    )
  }
}

export function sendPushNotificationToDriver(operatorId: string, message: string) {
  const { driverPushNotificationSuccess, driverPushNotificationFailure } = actionCreators
  const payload = {
    notification: {
      title: `GOIN' Updates`,
      body: `Schedule has been updated:\n${message}`
    },
    data: {
      extraInfo: null,
      operatorId
    }
  }

  return (dispatch: any) => {
    driversService
      .sendPushNotificationToDriver(payload)
      .then(() => dispatch(driverPushNotificationSuccess('Push notification succesfully sent to operator.')))
      .catch(() => dispatch(driverPushNotificationFailure('Error sending notification to operator.')))
  }
}
export type IDriverActions = ActionsUnion<typeof actionCreators>



// WEBPACK FOOTER //
// ./src/state/actions/drivers/index.ts